<template>
  <div class="ifRow pa-1 d-flex align-center flex-wrap">
    <v-menu
      offset-y
      offset-x
      :disabled="$vuetify.breakpoint.mdAndUp"
      rounded="lg"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          v-bind="attrs"
          v-on="on"
          outlined
          pill
          :color="ifTypes[rowType].color"
          class="me-2 py-5 pe-4 d-flex justify-center align-center"
          style="min-width: 150px"
        >
          <v-icon :color="ifTypes[rowType].color" class="me-2">
            {{ ifTypes[rowType].icon }}
          </v-icon>
          {{ ifTypes[rowType].title }}
        </v-chip>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title class="px-3 text-wrap">{{
            getText()
          }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <v-chip
      outlined
      pill
      :color="ifTypes[rowType].color"
      class="me-2 py-5 pe-4 d-flex justify-center align-center"
      style="min-width: 150px"
    >
      <v-icon :color="ifTypes[rowType].color" class="me-2">
        {{ ifTypes[rowType].icon }}
      </v-icon>
      {{ ifTypes[rowType].title }}
    </v-chip> -->
    <div
      v-if="$vuetify.breakpoint.mdAndUp"
      class="grey--text text--darken-2 ifRowText"
    >
      {{ getText() }}
    </div>
  </div>
</template>
<script>
export default {
  name: "IfRowContent",
  props: {
    ifRow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ifTypes: [],
    };
  },
  computed: {
    rowType() {
      return Object.keys(this.ifRow)[0];
    },
    devices() {
      const devices = this.$store.getters["devices/devices"];
      return Object.values(devices);
    },
    actions() {
      return [
        {
          value: ">",
          text: this.$t("bigger"),
        },
        {
          value: "<",
          text: this.$t("smaller"),
        },
        {
          value: "==",
          text: this.$t("equals"),
        },
        {
          value: "!=",
          text: this.$t("not-equals"),
        },
      ];
    },
  },
  created() {
    this.ifTypes = {
      scheduale: {
        title: this.$t("byTime"),
        icon: "mdi-clock-outline",
        color: "indigo lighten-1",
      },
      device: {
        title: this.$t("byDevice"),
        icon: "mdi-chip",
        color: "teal darken-1",
      },
      connection: {
        title: this.$t("byConnect"),
        icon: "mdi-access-point-network",
        color: "light-blue darken-1",
      },
      rssi: {
        title: this.$t("byRssi"),
        icon: "mdi-signal",
        color: "amber darken-2",
      },
      gateway_rssi: {
        title: this.$t("byGatewayRssi"),
        icon: "mdi-signal",
        color: "deep-orange accent-2",
      },
      output: {
        title: this.$t("byOutput"),
        icon: "mdi-flash",
        color: "green",
      },
    };
  },
  methods: {
    device(identifier) {
      return this.devices && identifier
        ? this.devices.filter((d) => d.identifier == identifier)[0]
        : null;
    },
    getText() {
      const val = Object.values(this.ifRow)[0];
      let text = "";
      let device = "if_sensor" in val ? this.device(val.if_sensor) : null;
      device = device ?? null;
      let controller =
        "if_controller" in val ? this.device(val.if_controller) : null;
      controller = controller ?? null;
      let toState = "to_state" in val ? this.device(val.to_state) : null;
      toState = toState ?? null;
      switch (this.rowType) {
        case "scheduale":
          text =
            this.$t("startTime") +
            ` ` +
            val.startTime +
            " " +
            this.$t("endTime") +
            " " +
            val.endTime +
            ", " +
            this.$t("days") +
            " - ";
          for (let i = 0; i < val.days.length; i++) {
            text += this.$t(`weekDays.${val.days[i]}`);
            if (i < val.days.length - 1) {
              text += ", ";
            }
          }
          return text;
        case "connection":
          text = device.name ? device.name + " - " : device.identifier + " - ";
          text += this.$t("connection-status") + ": " + this.$t(val.if_connect);
          return text;
        case "output":
          text = controller.name
            ? controller.name + " - "
            : controller.identifier + " - ";
          text +=
            this.$t("controller-output") + ": " + val.if_output == "on"
              ? this.$t("controllerOn")
              : this.$t("controllerOff");
          return text;
        case "rssi":
          text = device.name ? device.name + " - " : device.identifier + " - ";
          text += this.$t("by") + ": " + this.$t("signal-strength");
          return text;
        case "gateway_rssi":
          text =
            val.if_gateway +
            " - " +
            this.$t("from-to", {
              start: forceLTR(val.if_bottom_threshold),
              end: forceLTR(val.if_top_threshold),
            });
          return text;
        case "device":
          if (
            device.settings &&
            (device.settings.sensor_type <= 10 ||
              device.settings.sensor_type > 14) &&
            device.settings.sensor_type != 21 &&
            device.settings.sensor_type != 7
          ) {
            text = device.name
              ? `'${device.name}'` +
                " " +
                this.$t(val.if_sensorDevice) +
                " " +
                this.actions.filter(
                  (action) => action.value == val.if_action
                )[0].text +
                " "
              : device.identifier +
                " " +
                this.$t(val.if_sensorDevice) +
                " " +
                this.actions.filter(
                  (action) => action.value == val.if_action
                )[0].text +
                " ";
            text += toState
              ? toState.name
                ? toState.name
                : toState.identifier
              : val.to_state.includes("-")
              ? forceLTR(val.to_state)
              : val.to_state;
            // console.log("texttttttttttttttttt: ", text, forceLTR(val.to_state));
          } else {
            text = device.name
              ? device.name + " - "
              : device.identifier + " - ";
            if (device.settings && device.settings.sensor_type == 7) {
              text +=
                val.if_action == 1 ? this.$t("lightOn") : this.$t("lightOff");
            } else if (
              device.settings &&
              device.settings.sensor_type != 7 &&
              device.settings.sensor_type != 21
            ) {
              text += val.if_action == 1 ? this.$t("close") : this.$t("open");
            } else if (device.settings && device.settings.sensor_type == 21) {
              text +=
                val.if_action == 1 ? this.$t("vibrates") : this.$t("steady");
            }
          }
          return text;
        default:
          return "";
      }
    },
  },
};
function forceLTR(text) {
  return `\u202A${text}\u202C`;
}
</script>
<style lang="scss" scoped>
.ifRowText {
  line-height: 1.1;
}
</style>
